<div class="pie-container">
  <div data-cy="widget-title" class="pie-title">Pallets in / out (30 days)</div>
  <div *ngIf="initialized " 
    class="pie-content">
    <apx-chart #pieChart
               [chart]="chart"
               [series]="series"
               [labels]="labels"
               [dataLabels]="dataLabels"
               [theme]="theme"
               [legend]="legend"
               [tooltip]="tooltip"
               [stroke]="stroke">
    </apx-chart>
  </div>
</div>